import { useTellescopeQuery } from "@tellescope/tanstack-query";
import { useTranslation } from "react-i18next";
import { CallContextCard } from "./CallContextCard";
import { VoicemailContextCard } from "./VoicemailContextCard";

export interface CallOrVoicemailWrapperProps {
  phoneCallId: string;
}

export function CallOrVoicemailWrapper({ phoneCallId }: CallOrVoicemailWrapperProps) {
  const { t } = useTranslation("tickets");

  const callQuery = useTellescopeQuery({
    model: "phone_calls",
    method: "getOne",
    request: phoneCallId,
    enabled: !!phoneCallId,
  });

  if (callQuery.isLoading) {
    return (
      <div className="p-4 text-center text-muted-foreground">
        <p className="text-sm">{t("Loading call details...")}</p>
      </div>
    );
  }

  if (callQuery.isError || !callQuery.data) {
    return (
      <div className="p-4 border border-destructive rounded-lg">
        <p className="text-sm text-destructive">{t("Unable to load call details. Please try again.")}</p>
      </div>
    );
  }

  const call = callQuery.data;
  const isVoicemail = !!(call.recordingURI || call.recordingDurationInSeconds);

  return isVoicemail ? <VoicemailContextCard call={call} /> : <CallContextCard call={call} />;
}
